import { createContext, useContext } from 'react';
import {
  ContentDismissalService,
  DismissalReason,
} from '@moment/analytics/ContentDismissalService';

export const ContentDismissalContext = createContext<ContentDismissalService | null>(null);

export const useContentDismissal = () => {
    const context = useContext(ContentDismissalContext);
    if (context) {
        return context
    }
    return {
      startTracking: (_partner: string, _searchParams: URLSearchParams) => {
        /* no-op */
      },
      stopTracking: (_reason: DismissalReason) => {
        /* no-op */
      },
    };
};
